<template>
    <div class="old-new-section">
        <div class="container">
            <div class="row">
                <div class=" col-md-6 d-flex align-items-lg-stretch flex-column">
                    <div class="title__blck">
                        <div class="title">
                            <p class="p-black p-title-new relawayBold p-center">Hur det brukade vara</p>
                        </div>
                        <div class="desk">
                            <p class="min p-dgrey  p-center">Ring runt bland Sveriges elbolag och anteckna deras priser för att hitta det avtal du tror är billigt. Kontakta sedan manuellt ditt existerande elbolag och nätbolag för att be dem att byta ditt elavtal.</p>
                        </div>
                    </div>
                    <div class="img__blck">
                        <img src="../../../../img/old-way-img.svg" alt="" class="img-fluid first_img">
                    </div>
                </div>
                <div class=" col-md-6 d-flex align-items-lg-stretch  flex-column">
                    <div class="title__blck">
                        <div class="title">
                            <p class="p-black p-title-new relawayBold p-center">Hur det ska vara</p>
                        </div>
                        <div class="desk">
                            <p class="min p-dgrey  p-center">Ange ditt postnummer och årsförbrukning på TecknaEl. Vi jämför kostnadsfritt dagens priser för Sveriges elbolag och ger dig de billigaste alternativen, svart på vitt. Att byta avtal är sedan bara ett klick bort!</p>
                        </div>
                    </div>
                    <div class="img__blck ">
                        <img src="../../../../img/smart-way-img.svg" alt="" class="img-fluid">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OldNewWay"
    }
</script>
